import React from 'react';

import * as amplitude from '@amplitude/analytics-browser';
import { Box, Link, Modal, Stack, styled, Typography, Alert } from '@mui/material';

import { DropdownOptionButton } from '~components/shared/dropdown';
import { IconLiFinanceLogo, IconArbitrumLogo, IconSynapseLogo } from '~components/shared/icons';
import AppColors from '~components/theme/styles/colors';
export const StyledLink = styled(Link)({
  textDecoration: 'none',
  fontWeight: '600',
  color: AppColors.neutralGrey[3],
});

const LifiWidgetEmbed = styled('iframe')({
  border: '0px',
  borderRadius: '10px',
  margin: '0px auto',
  display: 'block',
  width: '100%',
  height: 'calc(100% - 160px)',
  zIndex: 1,
  pointerEvents: 'auto',
});

const LifiWidgetContainer = styled(Box)({
  pointerEvents: 'none',
  position: 'absolute',
  top: '50%',
  left: '55%',
  width: '500px',
  transform: 'translate(-50%, -50%)',
});

export const BridgesContent = () => {
  const [isModalOpen, setModalOpen] = React.useState<boolean>(false);

  return (
    <>
      <StyledLink>
        <DropdownOptionButton
          variant="primary"
          onClick={() => {
            setModalOpen(true);
            amplitude.track('bridge', { type: 'lifi' });
          }}
          sx={{ display: 'flex', justifyContent: 'start' }}
        >
          <Stack direction={'row'} sx={{ whiteSpace: 'nowrap' }}>
            <Box mt={'.5px'} width="20px">
              <IconLiFinanceLogo width={20} height={20} />
            </Box>
            <Typography fontSize={14} ml={1.5}>
              Lifi Bridge
            </Typography>
          </Stack>
        </DropdownOptionButton>
      </StyledLink>
      <StyledLink href={'https://bridge.arbitrum.io/'} target="_blank" rel="noopener noreferrer">
        <DropdownOptionButton
          variant="primary"
          onClick={() => {
            amplitude.track('bridge', { type: 'arb' });
          }}
        >
          <Stack direction={'row'} sx={{ whiteSpace: 'nowrap' }}>
            <Box mt={'.5px'} width="20px">
              <IconArbitrumLogo width={20} height={20} />
            </Box>
            <Typography fontSize={14} ml={1.5}>
              Arbitrum Bridge
            </Typography>
          </Stack>
        </DropdownOptionButton>
      </StyledLink>
      <StyledLink href={'https://synapseprotocol.com/'} target="_blank" rel="noopener noreferrer">
        <DropdownOptionButton
          variant="primary"
          onClick={() => {
            amplitude.track('bridge', { type: 'synapse' });
          }}
        >
          <Stack direction={'row'} sx={{ whiteSpace: 'nowrap' }}>
            <Box mt={'2px'} width="20px">
              <IconSynapseLogo width={18} height={18} />
            </Box>
            <Typography fontSize={14} ml={1.5}>
              Synapse Bridge
            </Typography>
          </Stack>
        </DropdownOptionButton>
      </StyledLink>
      <StyledLink href={'https://across.to/bridge'} target="_blank" rel="noopener noreferrer">
        <DropdownOptionButton
          variant="primary"
          onClick={() => {
            amplitude.track('bridge', { type: 'across' });
          }}
        >
          <Stack direction={'row'} sx={{ whiteSpace: 'nowrap' }}>
            <Box mt={'2px'} width="20px">
              <IconSynapseLogo width={18} height={18} />
            </Box>
            <Typography fontSize={14} ml={1.5}>
              Across Bridge
            </Typography>
          </Stack>
        </DropdownOptionButton>
      </StyledLink>
      <Modal
        open={isModalOpen}
        onClose={() => {
          setModalOpen(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box>
          <LifiWidgetContainer
            sx={{ padding: '1rem', height: '80%', background: 'white', borderRadius: '16px' }}
            position={'absolute'}
            width={'100%'}
          >
            <Typography paddingBottom="0.5rem" variant="h5">
              Buy VSTA via Li.Finance
            </Typography>
            <Alert sx={{ marginBottom: '0.5rem' }} severity="warning">
              As bridging services involve third parties, there may be rare instances where funds are stuck
              for up to 3 days (max) if there is an outage from the service provider. However, the users funds
              are always safely locked on the chain.
            </Alert>

            <LifiWidgetEmbed src="https://li.finance/embed?fromChain=arb&toChain=arb" />
          </LifiWidgetContainer>
        </Box>
      </Modal>
    </>
  );
};
